import React from 'react';
import { Col } from '../util_grid/grid.js';
import MarkdownToHtml from '../ui_markdown-to-html/component';
import PropTypes from 'prop-types';


const MarkdownComponent = (props) => {
  const { text = '' } = props;
  return (
    <Col className="markdown">
      <article>
        <MarkdownToHtml markdown = {text} />
      </article>
    </Col>
  );
};


MarkdownComponent.propTypes = {

  text: PropTypes.string,
};

export default MarkdownComponent;
